import axios from 'axios';
import VueElementLoading from 'vue-element-loading';
import { BasicSelect } from 'vue-search-select';
import Paginate from 'vuejs-paginate';
import Multiselect from 'vue-multiselect';
import apiUrl from '../../../constants';
import awsBucketName from '../../../constants';
import 'vue-multiselect/dist/vue-multiselect.min.css';
import { variables } from '../../../../config';
import moment from 'moment';
import { newAWB, RecReasonData } from '../../../services/getDataCall';
import { AWBNumberNormslization } from '../../../services/utility';
import { custom_sort } from '../../../services/utility';

export default {
  name: 'addeditloggedbyexecutive',
  components: {
    BasicSelect,
    Paginate,
    VueElementLoading,
    Multiselect,
  },
  data() {
    return {
      newhubs: '',
      newhublist: [],
      show: false,
      show1: false,
      show2: false,

      // for hun list
      hub: '',
      hublist: [],
      // for status
      Status: '',
      StatusList: [],
      // verification Status
      vStatus: '',
      vStatusList: [],
      myStr: '',
      todate: '',
      fromdate: '',
      octroi_MRP: '',
      awbnumber: '',
      listUserData: [],
      accesszonelist: '',
      parsedata: '',
      isLoading1: false,
      pagecount: 1,
      pageno: 0,
      currentPage: 1,
      totalPages: 0,
      showeditmodel: false,

      // pop-up fields
      awbnumberPop: '',
      regionName: '',
      hubName: '',
      currentHubName: '',
      destinationHubName: '',
      bagCondition: '',
      DEPSbagCondition: '',
      OctroiMRP: '',
      Clientname: '',
      productDescription: '',
      STDreason: '',
      description: '',
      hubOrigin: '',
      Currenthub: '',
      Destinationhub: '',
      lastService: '',

      // table
      tablehublist: [],
      currenthubname: '',
      originhubname: '',
      finaldestinationname: '',
      operator: '',
      // client list
      clienList: [],
      hubdroplist: [],
      editshowtable: false,
      exportdis: '',
      List: [],
      abc: '',
      primaryKey: '',
      showModal: false,
      imgData: '',
      ListData: [],
      errormsg: '',
      totalcount: 0,
      pageValue: 0,
      recreasons:[],
      Awb:[],
      RECReasonMap: {},
      link:`https://${awsBucketName.awsBucketName}.s3.ap-southeast-1.amazonaws.com/`



    };
  },
  mounted() {
    const userToken = window.localStorage.getItem('accessuserToken');
    this.myStr = userToken.replace(/"/g, '');
    this.accesszonelist = window.localStorage.getItem('accesszone');
    this.parsedata = JSON.parse(this.accesszonelist);
    this.getzonehubs();
    this.status();
    this.verificationStatus();
    this.recReasonFetchData()

    if(localStorage.getItem('financepageData') !== null){
      let pageNum = localStorage.getItem('pageNum');
      let input = JSON.parse(localStorage.getItem('financepageData'));
      localStorage.removeItem('financepageData');
      if(input === undefined) { input =''; }
      this.getPaginationData(pageNum?pageNum:1, input)
      localStorage.removeItem('pageNum')
    }
  },
  destroyed() {
    localStorage.removeItem('financepageData');
  },
  computed: {
    checkDisabled: function () {
      return (this.operator == '') ? true : false;
    },
    ExportDisableds: function () {
      return (this.exportdis == '') ? true : false;
    },
  },
  methods: {
    onFileChange() { },
    getzonehubs() {
      this.show = true;

      axios({
        method: 'post',
        url: `${apiUrl.api_url}getZoneList`,
        data: {},
        headers: {
          Authorization: `Bearer ${this.myStr}`,
        },
      }).then((result) => {
        this.show = false;
        const finalHubData = [];
        result.data.data.forEach((hub) => {
          finalHubData.push({
            id: hub.hubzoneid,
            label: hub.hubzonename,
          });
        });
        this.newhublist = finalHubData;
      },
        (error) => {
          this.show = false;
          console.error(error);
        });
    },

    callHub(newhublist) {
      this.hublist = [];

      this.getHubList(newhublist.id);
      this.hub = '';
      if (newhublist.id != undefined) {
        this.getHubList();
      }
    },

    verificationStatus() {
      axios({
        method: 'post',
        url: apiUrl.api_url + 'allVerificationStatus',
        data: this.input,
        headers: {
          'Authorization': 'Bearer ' + this.myStr
        }
      }).then(result => {
        let vstatusdata = []
        result.data.data.forEach((x) => {
          vstatusdata.push({
            id: x.investigationactionmasterid,
            label: x.actionname
          })
        })
        this.vStatusList = vstatusdata
      },
        error => {

          console.error(error)
        })

    },

    getregionname() {

      this.editshowtable = false;
      for (let j = 0; j < this.listUserData.length; j++) {
        for (let i = 0; i < this.newhublist.length; i++) {
          if (this.listUserData[j].hubzoneid !== null
            && this.listUserData[j].hubzoneid != undefined) {
            if (this.newhublist[i].id == this.listUserData[j].hubzoneid) {
              this.listUserData[j].regionname = this.newhublist[i].label;
            }
          }
        }
      }

      this.editshowtable = true;
    },



    status() {
      axios({
        method: 'post',
        url: `${apiUrl.api_url}status`,
        data: {},
        headers: {
          Authorization: `Bearer ${this.myStr}`,
        },
      }).then((result) => {
        const statusdata = [];
        result.data.data.forEach((status) => {
          if (status.statuscode === 1) {
            statusdata.push({
              id: status.statuscode,
              label: status.statusname,
            });
          }
        });

        this.StatusList = statusdata;
        //console.log(this.StatusList);
        this.Status = this.StatusList.find(status => status.id === 1)
      },
        (error) => {
          console.error(error);
        });
    },

    ImageView(awb1, status) {
      this.errormsg = ''
      this.abc = awb1;
      let path = '';
      this.primaryKey = 123;
      // if (status === 17 || status === 13) {
      //   path = `${awsBucketName}/STD/${awb1}`;
      // } else {
      //   path = `${awsBucketName}/${this.primaryKey}${awb1}`;
      // }
      path = `STD/${awb1}`;
      this.input = ({
        key: path,
      });

      axios({
        method: 'post',
        url: `${apiUrl.api_url}getListObjectFroms3`,
        data: this.input,
        headers: {
          Authorization: `Bearer ${this.myStr}`,
        },
      }).then((result) => {
        const images = result.data.data.Contents.sort(custom_sort);
        this.List = images.slice(0, 3);
        if (this.List.length <= 0) {
          this.errormsg = "No Image Found"
        }
      });
    },

    downloadImage(filePath) {
      // console.log(filePath);
      this.show1 = true;
      this.input = ({
        key: filePath,
        fileName: 'download.png',
      });

      axios({
        method: 'post',
        url: `${apiUrl.api_url}fetchImages3`,
        data: this.input,
        headers: {
          Authorization: `Bearer ${this.myStr}`,
        },
      }).then((result) => {
        this.show1 = false;
        //console.log('result from fetch api', result);
        const finalImage = result.data.ImageData.Body.data;
        let buff = new Buffer.from(finalImage);
        let base64data = buff.toString('base64');
        this.imgData = 'data:image/png;base64,' + base64data
        // console.log('finalImage: ', toBase64(finalImage));
      });


      this.showModal = true;
    },

    closeImage() {
      this.showModal = false;
    },

    getHubList(id) {
      const finalhublist = [];
      for (let i = 0; i < this.parsedata.hubaccess.length; i++) {
        if (id == this.parsedata.hubaccess[i].HubZoneId) {
          finalhublist.push({
            id: this.parsedata.hubaccess[i].HubID,
            label: this.parsedata.hubaccess[i].HubName,
          });
          this.hublist = finalhublist;
        }
      }
    },
    resetForm() {
      this.pageValue = 0

      this.Status = '';
      this.vStatus = '';
      this.octroi_MRP = '';
      this.hub = '';
      this.newhubs = '';
      this.todate = '';
      this.fromdate = '';
      this.awbnumber = '';
      this.exportdis = '';
      this.isLoading = false;
      this.$validator.reset(); this.errors.clear();
      this.isLoading1 = false;
      this.listUserData = []; this.pageno = 0; this.totalcount; this.pagecount = 1; this.totalRows = '';

    },

    searchUserData() {
      this.pageno = 0;
      this.$refs.paginate.selected = 0;
      this.searchData();
    },

    // get client list
    getClientList() {
      axios({
        method: 'post',
        url: `${apiUrl.api_url}getClientList`,
        data: {},
        headers: {
          Authorization: `Bearer ${this.myStr}`,
        },

      }).then((result) => {
        this.clienList = result.data.data;

        this.editshowtable = false;

        for (let j = 0; j < this.listUserData.length; j++) {
          for (let i = 0; i < this.clienList.length; i++) {
            if (this.listUserData[j].clientid !== null
              && this.listUserData[j].clientid != undefined) {
              if (this.clienList[i].ClientMasterID == this.listUserData[j].clientid) {
                this.listUserData[j].Clientname = this.clienList[i].CompanyName;
              }
            }
          }
        }
        this.editshowtable = true;
      },
        (error) => {
          this.show = false;
          console.error(error);
        });
    },

    // dropdown hub
    gethubdropdown() {
      axios({
        method: 'post',
        url: `${apiUrl.api_url}getHubdropdownlist`,
        data: {},
        headers: {
          Authorization: `Bearer ${this.myStr}`,
        },
      }).then((result) => {
        const finalHubData = [];
        result.data.data.forEach((hub) => {
          finalHubData.push({
            id: hub.HubID,
            label: hub.HubName,
          });
        });
        this.hubdroplist = finalHubData;
        this.editshowtable = false;

        for (let i = 0; i < this.hubdroplist.length; i++) {
          for (let j = 0; j < this.listUserData.length; j++) {
            if (this.listUserData[j].currenthubid !== null
              && this.listUserData[j].currenthubid != undefined) {
              if (this.hubdroplist[i].id == this.listUserData[j].currenthubid) {
                this.listUserData[j].currenthubname = this.hubdroplist[i].label;
              }
            }
          }
        }

        for (let i = 0; i < this.hubdroplist.length; i++) {
          for (let j = 0; j < this.listUserData.length; j++) {
            if (this.listUserData[j].originhubid !== null
              && this.listUserData[j].originhubid != undefined) {
              if (this.hubdroplist[i].id == this.listUserData[j].originhubid) {
                this.listUserData[j].originhubname = this.hubdroplist[i].label;
              }
            }
          }
        }
        for (let i = 0; i < this.hubdroplist.length; i++) {
          for (let j = 0; j < this.listUserData.length; j++) {
            if (this.listUserData[j].finaldestinationid !== null
              && this.listUserData[j].finaldestinationid != undefined) {
              if (this.hubdroplist[i].id == this.listUserData[j].finaldestinationid) {
                this.listUserData[j].finaldestinationname = this.hubdroplist[i].label;
              }
            }
          }
        }
        this.editshowtable = true;
      },
        (error) => {
          console.error(error);
        });
    },

    // to get pagination
    getPaginationData(pageNum, input='') {
      localStorage.setItem('pageNum', pageNum)
      this.pageValue = pageNum -1;
      this.pageno = (pageNum - 1) * variables.pageRecordLimit
      this.searchData(this.pageno, input)
    },
    Statusname() {
      axios({
        method: 'post',
        url: apiUrl.api_url + 'statusforstatusnames',
        data: {},
        headers: {
          'Authorization': 'Bearer ' + this.myStr
        }

      }).then(result => {
        this.StatusList2 = result.data.data;




        this.editshowtable = false;

        for (let j = 0; j < this.listUserData.length; j++) {

          for (let i = 0; i < this.StatusList2.length; i++) {
            if (this.listUserData[j]["status"] !== null && this.listUserData[j]["status"] != undefined) {

              if (this.StatusList2[i]["statuscode"] == this.listUserData[j]["status"]) {
                this.listUserData[j]["Statusname"] = this.StatusList2[i]["statusname"];

              }
            }
          }

        }

        this.editshowtable = true;

      },
        error => {
          this.show = false;
          console.error(error)
        })
    },
    buckettypecode() {

      axios({
        method: 'post',
        url: apiUrl.api_url + 'getinvestigationbuckettype',
        data: {},
        headers: {
          'Authorization': 'Bearer ' + this.myStr
        }

      }).then(result => {
        this.ListData = result.data.data;

        this.editshowtable = false;

        for (let j = 0; j < this.listUserData.length; j++) {

          for (let i = 0; i < this.ListData.length; i++) {
            if (this.listUserData[j]["buckettypecode"] !== null && this.listUserData[j]["buckettypecode"] != undefined) {

              if (this.ListData[i]["investigatbuckettypeid"] == this.listUserData[j]["buckettypecode"]) {
                this.listUserData[j]["Buckettypename"] = this.ListData[i]["buckettypename"];

              }
            }
          }

        }

        this.editshowtable = true;

      },
        error => {
          this.show = false;
          console.error(error)
        })
    },
    verificationStatusList() {
      this.editshowtable = false;
      for (let j = 0; j < this.listUserData.length; j++) {

        for (let i = 0; i < this.vStatusList.length; i++) {
          if (this.listUserData[j]["actionstatuscode"] !== null && this.listUserData[j]["actionstatuscode"] != undefined) {

            if (this.vStatusList[i]["id"] == this.listUserData[j]["actionstatuscode"]) {
              this.listUserData[j]["VerificationStatus"] = this.vStatusList[i]["label"];
            }
          }
        }

      }

      this.editshowtable = true;
    },
    NewAwb(data) {
      newAWB(data, this.myStr).then(result => {
        result.data.data.forEach((status) => {
          this.listUserData.forEach((data, i) => {
            if(data.shippingid === status.shippingid){
              this.listUserData[i]["newAWB"] = status.shippingid + 'REC';
              this.listUserData[i]["recreasionname"] = this.Recreasion(status.recreasonid)
            }
          });
        });
      });
    },

    Recreasion(data) {
      let RecReason;
      if(data !== null && data !== undefined){
        RecReason = this.RECReasonMap[data]
      }
      return RecReason;
    },

    recReasonFetchData(){
      RecReasonData(this.myStr).then(result => {
        this.recreasons= result.data.data;
        this.recreasons.map((reasons) => {
          this.RECReasonMap[reasons.recreasonsid] = reasons.recreason
        });
      },
        error => {
          this.show = false;
          console.error(error)
        })
    },
    // searchbutton
    searchData(pageNo,input='') {
      this.awbnumber = AWBNumberNormslization(this.awbnumber).toString();
      this.isLoading1 = true;
      this.show2 = true
      this.listUserData = []; this.pagecount = 1; this.totalRows = '';
      this.exportdis = 1;
      this.totalcount = 0
      var formats= /[`!@#$%^&*()_+\-=\[\]{};':"\\|.<>\/?~]/
      if(formats.test(this.awbnumber))
      {
        this.$alertify.error("Please Search Comma Seprated Shippingids")
      }
      else{  
      if (this.vStatus.id) {
        var vid = this.vStatus.id;
        var vstatusid = vid.toString();
      }
      if ((this.fromdate && !this.todate) || (!this.fromdate && this.todate)) {
        this.$alertify.error("Please enter both  date")

      }
      else if (this.fromdate > this.todate) {
        this.$alertify.error("From date should not be greater than To date")

      } else if ((this.fromdate && this.todate) || (!this.fromdate && !this.todate)) {

      this.input = ({
        offset: pageNo,
        limit: variables.pageRecordLimit,
        shippingid: this.awbnumber,
        FromDate: this.fromdate,
        ToDate: this.todate,
        status: this.Status.id,
        actionstatuscode: vstatusid,
        hubzoneid: this.newhubs.id,
        //originhubid: this.hub.id,
        currenthubid: this.hub.id,
        operator: this.operator,
        netvalue: this.octroi_MRP,
      });
      if(input === ''){
      localStorage.setItem('financepageData', JSON.stringify(this.input))
      }
      axios({
        method: 'post',
        url: `${apiUrl.api_url}searchApiAddEditRaiseDEPSLoggedByExecutive`,
        data: input? input : this.input,
        headers: {
          Authorization: `Bearer ${this.myStr}`,
        },
      }).then((result) => {
        this.show2 = false
        this.listUserData = result.data.data;
        this.totalcount = result.data.count?result.data.count:0
        if (this.totalcount == undefined) {
          this.totalcount = 0
        }
        this.NewAwb(this.listUserData);
        this.getClientList();
        this.gethubdropdown();
        this.getregionname();
        this.Statusname();
        this.buckettypecode();
        this.verificationStatusList()
        this.getDisputeStatusName(result.data.data);
        this.Recreasion();

        if (this.totalcount < variables.pageRecordLimit) {
          this.pagecount = 1;
        } else {
          this.pagecount = Math.ceil(result.data.count / variables.pageRecordLimit);
        }
      });
    }//else
  }//else
    },
    async getDisputeStatusName(data){
      let i = 0;
      for(let d of data){
        if(d.disputestatuscode !== null && d.disputestatuscode !== undefined && d.disputestatuscode !== '' &&
           d.status !== null && d.status !== undefined && d.status !== ''){
          this.input = ({
            Status: d.status,
            DisputeStatusCode: d.disputestatuscode
          });
          let result = await this.getDisputeStatusNameAPICall(this.input);
          this.listUserData[i].disputstatusname = result
        }else{
          this.listUserData[i].disputstatusname = '-'
        }
        i++;
      }
    },

    getDisputeStatusNameAPICall(input){
      return new Promise((resolve, reject) => {
        axios({
          method: 'post',
          url: apiUrl.api_url + 'DisputeSubStatus',
          data: input,
          headers: {
            'Authorization': 'Bearer ' + this.myStr
          }
        }).then(result => {
          return resolve(result.data.data[0]?result.data.data[0].pickupstatusname: '-');
        }).catch(err => {
          return reject (err);
        })
      })
    },
    exportfileCSV() {
      this.isLoading1 = true;
      this.downloadCSV(this.listUserData);
    },

    async downloadCSV(result) {
      const csvData = result;
      const today = new Date();
      const dd = today.getDate();
      const mm = today.getMonth() + 1;
      const yyyy = today.getFullYear();
      const todayDate = `${dd}${mm}${yyyy}`;
      let data; let filename; let
        link;
      filename = `add_logged_by_executive${todayDate}.csv`;
      let csv = await this.convertArrayOfObjectsToCSV({
        data: csvData,
      });
      if (csv == null) return;
      filename = filename || 'export.csv';
      if (!csv.match(/^data:text\/csv/i)) {
        csv = `data:text/csv;charset=utf-8,${csv}`;
      }
      data = csv;
      link = document.createElement('a');
      link.setAttribute('href', data);
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
    },
    convertArrayOfObjectsToCSV: function (args) {
      var result, ctr, keys, columnDelimiter, lineDelimiter, data;
      data = args.data || null;
      if (data == null || !data.length) {
        return null;
      }
      //columnDelimiter = args.columnDelimiter || ",";
      lineDelimiter = args.lineDelimiter || "\n";
      //keys = Object.keys(data[0]).slice(0);
      columnDelimiter = "ShippingID,ClientName,OctrioMRP,hubzoneid,HubZoneName,CurrentHubName,OriginHubid,OriginHubName,DestinationHubName,DisputeSatusName,Requestfrom,CreatedBy,OrderType,PhysicalWeight,VolumetricWeight,LoggedDate,LoggedDescription,ColoaderName,BagCondition,Contents,StatusName,VerificationStatus,STDBagCondition,verifieddate,verifieddescription,approvaldate,approvaldescription,lastmodifiedby,ManifestInScanDate,shortagetype,bagno,recreasionname";
      result = "";
      result += columnDelimiter;
      result += lineDelimiter;
      for (let i = 0; i < data.length; i++) {
        result += (data[i].shippingid).toString()+ ',' + data[i].Clientname + ',' + data[i].netvalue + ',' + data[i].hubzoneid + ',' + data[i].hubzonename + ','  + data[i].currenthubname + ',' + data[i].originhubid + ',' + data[i].originhubname + ',' + data[i].finaldestinationname + ','  + data[i].disputstatusname + ',' + data[i].Buckettypename + ',' + data[i].createdby + ',' + data[i].ordertype + ',' +data[i].phyweight+ ',' + data[i].volweight + ',' +  moment(new Date(data[i].createddate)).format("DD/MM/YYYY") + ',' + data[i].loggeddescription + ',' + data[i].coloaderid + ',' + data[i].stdbagcondition + ',' + data[i].productinformation + ',' + data[i].Statusname + ',' + data[i].VerificationStatus + ',' + data[i].stdbagcondition + ','  + moment(new Date(data[i].verifieddate)).format("DD/MM/YYYY") + ',' + data[i].verifieddescription +',' + data[i].approvaldate + ',' + data[i].approvaldescription + ',' + data[i].lastmodifiedby +',' +  moment(new Date(data[i].createddate)).format("DD/MM/YYYY") +',' + data[i].shortagetype +',' + data[i].bagno +',' + data[i].recreasionname   ;

        result += lineDelimiter;


      }
      return result;
    },
    // Open edit model
    neweditpage(awb, originhubname, currenthubname, currenthubid, finaldestinationname, regionname, status, id,bagcondition,netvalue,Clientname,hubzoneid) {

      this.$router.push({
        path: '/EditExcutive',
        query: {
          awb: awb,
          originhubname,
          currenthubname,
          currenthubid,
          finaldestinationname,
          regionname,
          status,
          id,
          bagcondition,
          netvalue,
          Clientname,
          hubzoneid
        },
      });
    },

    // close edit model
    closeEditModal() {
      this.showeditmodel = false;
    },
    // Open add edit screen
    neweditpage1() {
      // localStorage.removeItem('financepageData')

      this.$router.push({ path: '/AddExcutive' });
    },

  },
};



// WEBPACK FOOTER //
// ./src/views/components/AddEditSTDLoggedByExecutive/AddEditSTDLoggedByExecutive.component.js